/** @module csi/widget/QueryMessage */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/on",
	"dijit/_WidgetBase",
	"csi/constants",
	"csi/html",
	"csi/locale",
	"csi/state"
], function(declare, domClass, on, _WidgetBase, constants, html, locale, state) {

	return declare(_WidgetBase, {
		/** @property {string} text - message text */
		text: "",

		/** @property {Object} _handle - onclick event handle */
		_handle: null,

		/**
		 * Remove handle when destroyed
		 */
		destroy: function() {
			if (this._handle) {
				this._handle.remove();
			}

			this.inherited(arguments);
		},

		/**
		 * Extension point for responding to click event on query count
		 */
		onClickCount: function() { },

		/**
		 * Write text to DOM; if it includes the query count and has reached the limit, then provide onclick behavior to get full count
			 * @param {string} value
		 */
		_setTextAttr: function(value) {
			var domNode = this.domNode;
			var self = this;

			html.clear(domNode);

			if (this._handle) {
				this._handle.remove();
				this._handle = null;
			}

			domClass.toggle(domNode, "csi-query-message-empty", !value);

			if (value && !state.get("print")) {
				var queryLimit = locale.resource("QueryLimitCount", [constants.QUERY_COUNT_LIMIT]);
				var a = value.split(queryLimit);
				if (a.length > 1) {
					html.create("span", {
						innerText: a[0]
					}, domNode);

					var span = html.create("span", {
						"class": "csiCursorPointer",
						innerText: queryLimit,
						title: locale.resource("QueryLimitCountTitle")
					}, domNode);

					this._handle = on(span, "click", function() {
						self.onClickCount();
					});

					html.create("span", {
						innerText: a[1]
					}, domNode);

					return;
				}
			}

			html.text(domNode, value);
		}
	});
});
